import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import items from './announcements/items';
import active from './announcements/active';
import archived from './announcements/archived';
import scheduled from './announcements/scheduled';
import draft from './announcements/draft';

const announcements = combineReducers({
  items,
  active,
  archived,
  scheduled,
  draft,
  isLoading: loadingStatusAccordingToReducer('announcementsStatusLoadingStatus'),
});

export default announcements;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/announcements.reducer.js